import {DatasetDataLagLeadRequest} from "api/model/requests";
import {ChronoUnitLegacy} from "utils/time-utils";
import {InstantDoubleValue} from "api/model/dataset/InstantDoubleValue";
import {DatasetDataInfoResponse} from "api/model/dataset/DatasetDataInfoResponse";
import {ICombinedData, IDataConfigLocal, IDataSetConfig} from "./common/api/interfaces/interfaces";

export const getExtractedDataValue = (data: any, decimalPlace?: number): any => {
    if (data.length > 0) {
        const value = data[data.length - 1]?.value;
        if (typeof value === 'number') {
            return value.toFixed(decimalPlace != null ? decimalPlace : 2);
        }
        return value;
    }
    return null;
};


export const formatValueWithGivenDecimalPlace = (dataNumber: number, value: String, decimalPlace?: number) => {
    return dataNumber.toFixed(decimalPlace != null ? decimalPlace : 2) + " " + value;
}

export const formatISOToBasicDateFormat = (oldDate: string): string => {
    let dateFromString = new Date(oldDate);
    let returnDate = new Date(oldDate);

    returnDate.setMinutes(dateFromString.getMinutes() - dateFromString.getTimezoneOffset());

    let returnISO = returnDate.toISOString();

    returnISO = returnISO.replace("T", " ");
    returnISO = returnISO.split('.')[0];

    return returnISO;
}

export const formatDateByDateFrequency = (dateFrequency: ChronoUnitLegacy, date: Date): Date => {
    let newDate = date

    if (dateFrequency === "DAYS") {
        newDate.setHours(0);
        newDate.setMinutes(0);
    } else if (dateFrequency === "HOURS") {
        newDate.setMinutes(0);
    }

    newDate.setSeconds(0);
    newDate.setMilliseconds(0);

    return newDate
}

export const getDataConfigLocalFullyFilledConfig = (configLocal: IDataConfigLocal) => {
    let configToSend: DatasetDataLagLeadRequest = {};

    if (configLocal.alignStartTo) {
        configToSend.startAlignUnit = configLocal.alignStartTo as ChronoUnitLegacy;
    } else {
        configToSend.startAlignUnit = "HOURS" as ChronoUnitLegacy;
    }

    if (configLocal.timeOffset) {
        configToSend.lag = -1 * configLocal.timeOffset;
        configToSend.lead = configLocal.timeOffset;
    } else {
        configToSend.lag = 0;
        configToSend.lead = 0;
    }

    if (configLocal.timeOffsetUnits) {
        configToSend.lagUnit = configLocal.timeOffsetUnits as ChronoUnitLegacy;
        configToSend.leadUnit = configLocal.timeOffsetUnits as ChronoUnitLegacy;
    } else {
        configToSend.lagUnit = "HOURS" as ChronoUnitLegacy;
        configToSend.leadUnit = "HOURS" as ChronoUnitLegacy;
    }

    return configToSend
}

export const getDateFromGivenConfig = (config: IDataConfigLocal) => {
    let firstTimeDate = new Date();
    let lag = config.timeOffset ? config.timeOffset : 0;

    if (config.alignStartTo) {
        if (config.alignStartTo === 'DAYS') {
            firstTimeDate.setHours(0);
            firstTimeDate.setMinutes(0);
            firstTimeDate.setSeconds(0);
            firstTimeDate.setMilliseconds(0);
        } else if (config.alignStartTo === 'HOURS' || !config.alignStartTo) {
            firstTimeDate.setMinutes(0);
            firstTimeDate.setSeconds(0);
            firstTimeDate.setMilliseconds(0);
        }
    }

    if (config.timeOffsetUnits) {
        if (config.timeOffsetUnits === 'DAYS') {
            firstTimeDate.setTime(firstTimeDate.getTime() + lag * 24 * 60 * 60 * 1000);
        } else if (config.timeOffsetUnits === 'MINUTES') {
            firstTimeDate.setTime(firstTimeDate.getTime() + lag * 60 * 1000);
        } else {
            firstTimeDate.setTime(firstTimeDate.getTime() + lag * 60 * 60 * 1000);
        }
    } else {
        firstTimeDate.setTime(firstTimeDate.getTime() + lag * 60 * 60 * 1000);
    }

    return firstTimeDate;
}

export const numberArrayToBooleanConverter = (value?: Array<InstantDoubleValue>) => {
    if (!value) {
        return undefined;
    }
    if (value.length === 0) {
        return undefined;
    }

    return value[0].value !== 0;
}

export const remakeArrayIntoOtherInterface = (data: any, datasets: Array<IDataSetConfig>) => {
    const gotDataArr: DatasetDataInfoResponse[] = data;
    const arr: ICombinedData[] = [];

    for (let i = 0; i < gotDataArr.length; i++) {
        const givenToggle = datasets[i].toggle;
        let toggle = false;
        let toggleData;
        if (givenToggle) {
            toggle = givenToggle;
            toggleData = numberArrayToBooleanConverter(gotDataArr[i].data);
        }

        let decimalPlaces = 2;
        if (datasets[i] && datasets[i].decimalPlaces != null) {
            decimalPlaces = datasets[i].decimalPlaces as number
        } else if (gotDataArr[i] && gotDataArr[i].decimalPlaces != null) {
            decimalPlaces = gotDataArr[i].decimalPlaces as number
        }

        const a: ICombinedData = {
            identifier: gotDataArr[i].identifier,
            title: gotDataArr[i].title,
            data: gotDataArr[i].data,
            unit: gotDataArr[i].unit,
            overriddenTitle: datasets[i].overriddenTitle || "",
            decimalPlaces,
            description: datasets[i].description || "",
            type: datasets[i].type?.toUpperCase() || "NUMBER",
            enum: datasets[i].enum
        };

        if (datasets[i].toggle) {
            a.type = "BOOLEAN"
        }

        arr.push(a);
    }

    return arr;
}
